import { render } from "./ProcentIcon.vue?vue&type=template&id=14bd2201"
import script from "./ProcentIcon.vue?vue&type=script&lang=js"
export * from "./ProcentIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__